import React from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/breadcrumb/breadcrumb.css";
const Breadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();
  return (
    <nav className="breadcrumb-container" aria-label="Fil d'ariane">
      <ul className="breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={index}>
              <li>
                <span
                  className={isLast ? "breadcrumb_active" : ""}
                  onClick={(e) => {
                    if(item.fonction){
                      item.fonction();
                    }
                    if (item.link) {
                      navigate(item.link);
                    }
                    
                  }}
                >
                  {item.label}
                </span>
              </li>

              {!isLast && <li className="separator">{">"}</li>}
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
